import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { proposals } from "@/lib/api";

export default function ArchivedResponses() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState("");

  const load = async () => {
    setLoading(true);
    try {
      setItems((await proposals.list()).filter((p) => p.status === "archived"));
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  const restore = async (p) => { setBusy(p.id); try { await proposals.restore(p.id); await load(); } catch (e) { window.alert(e?.response?.data?.detail || "Restore failed"); } finally { setBusy(""); } };
  const remove = async (p) => {
    if (!window.confirm(`Permanently delete "${p.title}"? This cannot be undone.`)) return;
    setBusy(p.id); try { await proposals.remove(p.id); await load(); } catch (e) { window.alert(e?.response?.data?.detail || "Delete failed"); } finally { setBusy(""); }
  };

  return (
    <div className="page" data-testid="page-archived-responses">
      <div className="page-header">
        <div>
          <div className="page-title">Archived Responses</div>
          <div className="page-subtitle">{items.length} archived · restore any to send it back to Active</div>
        </div>
      </div>

      <div className="card">
        <table className="data-table">
          <thead><tr><th>Title</th><th>Agency</th><th>Type</th><th>Was</th><th style={{ textAlign: "right" }}>Actions</th></tr></thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={5}><div className="center-load"><span className="spinner" /> Loading…</div></td></tr>
            ) : items.length === 0 ? (
              <tr><td colSpan={5} style={{ textAlign: "center", padding: 28, color: "var(--text-secondary)" }}>No archived responses yet.</td></tr>
            ) : items.map((p) => (
              <tr key={p.id} data-testid={`archived-row-${p.id}`}>
                <td style={{ cursor: "pointer", fontWeight: 600 }} onClick={() => navigate(`/workspace?proposal=${p.id}`)}>{p.title}</td>
                <td>{p.agency}</td>
                <td>{p.rfp_type}</td>
                <td><span className="pill pill-orange">{(p.archived_from || "draft").replace(/_/g, " ")}</span></td>
                <td style={{ textAlign: "right", whiteSpace: "nowrap" }}>
                  <button className="btn btn-ghost btn-sm" onClick={() => navigate(`/workspace?proposal=${p.id}`)}>Open</button>
                  <button className="btn btn-ghost btn-sm" onClick={() => restore(p)} disabled={busy === p.id} data-testid={`restore-${p.id}`}>Restore</button>
                  <button className="btn btn-ghost btn-sm" style={{ color: "var(--danger)" }} onClick={() => remove(p)} disabled={busy === p.id} data-testid={`delete-${p.id}`}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
